import FaqScreen from './Faq';

export {FaqScreen};
